export default __webpack_public_path__ + "static/media/welcome-banner-bee.7b29a35b.svg";